import { useEffect } from 'react';

export function useUnmountEffect(fn: () => void) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => () => fn(), []);
}
